// import { useLocation } from 'react-router';
import { AppTabsPanelContainer } from '../../components/AppTabsPanelContainer';
import { Stack, styled } from '@mui/system';
import { Typography } from '@mui/material';

const StyledContainer = styled(Stack)(({ theme }) => ({
    height: '100%',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
}));

export function LogoutSuccess() {
    return (
        <AppTabsPanelContainer>
            <StyledContainer>
                <Typography variant="h3" mb={2}>
                    Logged Out!
                </Typography>
                <Typography variant="body1">Successfully logged out of STS UI</Typography>
            </StyledContainer>
        </AppTabsPanelContainer>
    );
}
